@if(pageInfo.urls && pageInfo?.['title'] && !pageInfo?.['compactHeader']) {
<div
  class="breadcrumb-container rounded p-y-30 p-x-24 m-b-30 overflow-hidden d-flex align-items-center justify-content-between"
>
  <h4 class="page-title m-0 f-s-20 f-w-600">
    {{ pageInfo?.['title'] }}
  </h4>
  <div class="d-flex align-items-center overflow-hidden">
    <ul class="breadcrumb">
      <!-- Muestra elementos de navegación solo si hay un título -->
    </ul>
  </div>
</div>
}
